import { gql } from "@apollo/client";

const USER_SEARCH = gql`
  query UserSearch($count: Int, $query: String!) {
    userSearch(count: $count, query: $query) {
      _id
      id
      avatar
      avatarUrl
      username

      discord {
        id
      }
    }
  }
`;

export { USER_SEARCH };
